// SAPS3 Latin America Reference Table
// Score SAPS3 -> Expected Mortality Rate
export const saps3LatinAmericaTable = {
  1: 0.0003,
  2: 0.0004,
  3: 0.0005,
  4: 0.0006,
  5: 0.0007,
  6: 0.0008,
  7: 0.001,
  8: 0.0011,
  9: 0.0014,
  10: 0.0016,
  11: 0.0019,
  12: 0.0022,
  13: 0.0026,
  14: 0.003,
  15: 0.0035,
  16: 0.0041,
  17: 0.0047,
  18: 0.0055,
  19: 0.0064,
  20: 0.0074,
  21: 0.0085,
  22: 0.0098,
  23: 0.0113,
  24: 0.013,
  25: 0.0149,
  26: 0.017,
  27: 0.0194,
  28: 0.0222,
  29: 0.0252,
  30: 0.0287,
  31: 0.0325,
  32: 0.0368,
  33: 0.0417,
  34: 0.047,
  35: 0.053,
  36: 0.0595,
  37: 0.0668,
  38: 0.0748,
  39: 0.0836,
  40: 0.0933,
  41: 0.1038,
  42: 0.1152,
  43: 0.1277,
  44: 0.1411,
  45: 0.1556,
  46: 0.1711,
  47: 0.1876,
  48: 0.2052,
  49: 0.2239,
  50: 0.2435,
  51: 0.2641,
  52: 0.2846,
  53: 0.308,
  54: 0.331,
  55: 0.3548,
  56: 0.3791,
  57: 0.4038,
  58: 0.4288,
  59: 0.454,
  60: 0.4792,
  61: 0.5043,
  62: 0.5292,
  63: 0.5538,
  64: 0.578,
  65: 0.6016,
  66: 0.6246,
  67: 0.6468,
  68: 0.6683,
  69: 0.689,
  70: 0.7088,
  71: 0.7277,
  72: 0.7457,
  73: 0.7628,
  74: 0.779,
  75: 0.7942,
  76: 0.8086,
  77: 0.8221,
  78: 0.8347,
  79: 0.8466,
  80: 0.8576,
  81: 0.868,
  82: 0.8776,
  83: 0.8866,
  84: 0.8949,
  85: 0.9026,
  86: 0.9098,
  87: 0.9165,
  88: 0.9226,
  89: 0.9284,
  90: 0.9336,
  91: 0.9385,
  92: 0.9431,
  93: 0.9473,
  94: 0.9511,
  95: 0.9547,
  96: 0.958,
  97: 0.9611,
  98: 0.9639,
  99: 0.9665,
  100: 0.969,
  101: 0.9712,
  102: 0.9733,
  103: 0.9752,
  104: 0.977,
  105: 0.9786,
  106: 0.9801,
  107: 0.9815,
  108: 0.9828,
  109: 0.984,
  110: 0.9851,
  111: 0.9862,
  112: 0.9871,
  113: 0.988,
  114: 0.9888,
  115: 0.9896,
  116: 0.9903,
  117: 0.9909,
  118: 0.9915,
  119: 0.9921,
  120: 0.9926,
  121: 0.9931,
  122: 0.9936,
  123: 0.994,
  124: 0.9944,
  125: 0.9948,
  126: 0.9951,
  127: 0.9954,
  128: 0.9957,
  129: 0.996,
  130: 0.9962,
  131: 0.9965,
  132: 0.9967,
  133: 0.9969,
  134: 0.9971,
  135: 0.9973,
  136: 0.9974,
  137: 0.9976,
  138: 0.9978,
  139: 0.9979,
  140: 0.998,
  141: 0.9981,
  142: 0.9983,
  143: 0.9984,
  144: 0.9985,
  145: 0.9985,
  146: 0.9986,
  147: 0.9987,
  148: 0.9988,
  149: 0.9989,
  150: 0.9989
};

/**
 * Get expected mortality rate for a given SAPS3 score
 * @param {number} saps3Score - The SAPS3 score
 * @returns {number} - Expected mortality rate (0-1)
 */
export function getExpectedMortality(saps3Score) {
  if (saps3Score < 1) return saps3LatinAmericaTable[1];
  if (saps3Score > 150) return saps3LatinAmericaTable[150];
  
  // Use exact score if available, otherwise interpolate
  if (saps3LatinAmericaTable[saps3Score]) {
    return saps3LatinAmericaTable[saps3Score];
  }
  
  // Linear interpolation for scores not in the table
  const lowerScore = Math.floor(saps3Score);
  const upperScore = Math.ceil(saps3Score);
  
  if (lowerScore === upperScore) {
    return saps3LatinAmericaTable[lowerScore] || 0;
  }
  
  const lowerRate = saps3LatinAmericaTable[lowerScore] || 0;
  const upperRate = saps3LatinAmericaTable[upperScore] || 1;
  
  const fraction = saps3Score - lowerScore;
  return lowerRate + (upperRate - lowerRate) * fraction;
}

/**
 * Calculate SMR (Standardized Mortality Ratio) for a dataset
 * @param {Array} patients - Array of patient data with saps3Score and outcome
 * @returns {Object} - SMR calculation results
 */
export function calculateSMR(patients) {
  if (!patients || patients.length === 0) {
    return {
      smr: 0,
      observedDeaths: 0,
      expectedDeaths: 0,
      totalPatients: 0
    };
  }
  
  let observedDeaths = 0;
  let expectedDeaths = 0;
  
  patients.forEach(patient => {
    if (patient.outcome === 'death' || patient.outcome === 'óbito' || patient.outcome === 1) {
      observedDeaths++;
    }
    
    const expectedMortality = getExpectedMortality(patient.saps3Score || patient.saps3 || 0);
    expectedDeaths += expectedMortality;
  });
  
  const smr = expectedDeaths > 0 ? observedDeaths / expectedDeaths : 0;
  
  return {
    smr: smr,
    observedDeaths,
    expectedDeaths,
    totalPatients: patients.length,
    observedMortalityRate: observedDeaths / patients.length,
    expectedMortalityRate: expectedDeaths / patients.length
  };
}

/**
 * Get SAPS3 score ranges for risk stratification
 * @returns {Array} - Risk stratification ranges
 */
export function getSAPS3RiskRanges() {
  return [
    { range: '1-30', label: 'Baixo Risco', min: 1, max: 30, color: '#10b981' },
    { range: '31-50', label: 'Risco Moderado', min: 31, max: 50, color: '#f59e0b' },
    { range: '51-70', label: 'Risco Alto', min: 51, max: 70, color: '#ef4444' },
    { range: '71+', label: 'Risco Muito Alto', min: 71, max: 150, color: '#7c3aed' }
  ];
}

export default saps3LatinAmericaTable;
